import { Link } from "react-router-dom";
import { dramas } from "@/mocks/dramas";
import DramaCard from "@/components/base/DramaCard";
import SectionHeading from "@/components/base/SectionHeading";

export default function HotDramas() {
  const hot = [...dramas].sort((a, b) => b.heat - a.heat).slice(0, 8);

  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <SectionHeading
        eyebrow="Hot Picks"
        title="热门影视信息"
        description="根据站内热度整理，精选 8 部最受欢迎的仙剑及仙侠影视作品，点击卡片即可查看完整剧情与角色介绍。"
        action={
          <Link
            to="/category"
            className="inline-flex items-center gap-2 h-10 px-5 rounded-md border border-primary-300 text-primary-700 hover:bg-primary-50 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer"
          >
            查看全部剧集
            <i className="ri-arrow-right-line"></i>
          </Link>
        }
      />
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
        {hot.map((drama) => (
          <DramaCard key={drama.id} drama={drama} />
        ))}
      </div>
    </section>
  );
}